import React from 'react';

interface FaqQuestionProps {
    question: string;
    answer: string;
}

/**
 * A single FAQ entry, rendered as a native `<details>/<summary>` disclosure.
 * The answer stays present in the DOM even while collapsed (unlike a
 * JS-only accordion), which keeps it fully crawlable by search engines and
 * LLM/AI crawlers while still giving visitors a compact, expandable list.
 */
const FaqQuestion: React.FC<FaqQuestionProps> = ({ question, answer }) => {
    return (
        <details className="faq-item">
            <summary className="faq-question">{question}</summary>
            <p className="faq-answer">{answer}</p>
        </details>
    );
};

export default FaqQuestion;
